var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "section form-column" },
        [
          _c(
            "el-form",
            {
              staticStyle: { height: "100%" },
              attrs: {
                "label-width": "50px",
                "label-position": "right",
                inline: ""
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Search2") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      placeholder: _vm.$t(
                        "SystemMaintenance.PleaseCodeEnglishNameName"
                      )
                    },
                    on: { input: _vm.applyFilter },
                    model: {
                      value: _vm.typedText,
                      callback: function($$v) {
                        _vm.typedText = $$v
                      },
                      expression: "typedText"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.branchShow,
                      expression: "branchShow"
                    }
                  ],
                  attrs: { label: _vm.$t("SystemMaintenance.Branch") }
                },
                [
                  _c(
                    "el-select",
                    {
                      on: { change: _vm.companyHandler },
                      model: {
                        value: _vm.officeId,
                        callback: function($$v) {
                          _vm.officeId = $$v
                        },
                        expression: "officeId"
                      }
                    },
                    _vm._l(_vm.offices, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.chineseName, value: item.officeId }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.enterHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "default" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }